import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useRef, useState } from "react";
import { list_comment, sendComment, sendCommentNew, teacherBackground, teacherStepAccept, approveRejectBgReupload } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import Swal from "sweetalert2";
import { TOAST_ERROR, TOAST_SUCCESS, TOAST_WARNING } from "../../../utils/common.service";
import { useFormik } from "formik";
import * as Yup from "yup";
import FileModal from "../../../components/FileModal";
import DataTable from "react-data-table-component";
import customStyles from "../../../utils/dataTableStyles";

export default function TBackground({ isLoader }) {

    const [data, setData] = useState([])
    const [commentsList, setCommentsList] = useState([]);
    const [isCommentSent, setIsCommentSent] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    const teacherID = (location.state && location.state.teacherId) || new URLSearchParams(location.search).get('teacherId');
    const name = (location.state && location.state.teacherName) || new URLSearchParams(location.search).get('teacherName');

    const GetTBackgroundData = () => {
        isLoader(true)
        teacherBackground({ teacher_id: teacherID }).then((response) => {
            console.log('teacherBackground :', response);
            if (response.code == 1) {
                setData(response.data[0])
                isLoader(false)
            } else {
                setData([])
                isLoader(false)
            }
        })
    }

    const GetTApplicationComments = async () => {
        try {
            isLoader(true);
            const response = await list_comment({ comment_id: teacherID, action_type: "300" });
            console.log('response :', response);
            if (response.code == 1) {
                const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                setCommentsList(dataWithRowCount);
            } else if (response.code == 0) {
                TOAST_ERROR(response.message);
            }
        } catch (error) {
            console.log('error :', error);
            TOAST_ERROR(error);
        } finally {
            isLoader(false);
        }
    };

    const columns = [
        {
            name: 'No',
            selector: row => row.count,
            sortable: false,
            width: "70px"
        },
        {
            name: "Date",
            selector: row => {
                const date = new Date(row.created_at);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const formattedMonth = month < 10 ? `0${month}` : month;
                const formattedDay = day < 10 ? `0${day}` : day;
                const year = date.getFullYear();
                return `${formattedDay}-${formattedMonth}-${year}`;
            },
            sortable: true,
        },
        {
            name: "Admin name",
            selector: row => row.admin_name,
            sortable: true,
        },
        {
            name: "Comment",
            selector: row => row.comment,
            sortable: true,
        },
    ]

    useEffect(() => {
        GetTBackgroundData();
        GetTApplicationComments();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    const handleAccpet = () => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to accept teacher background details?",
            showCancelButton: true,
            confirmButtonText: "Accept",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    var objAccept = {
                        teacher_id: teacherID,
                        email: data.email,
                        accept: "2",
                        step: "3",
                        accept_for: "1", //aceept_for 1 = teacher , 2 = organization_teacher
                        teacher_name: name
                    };
                    isLoader(true)
                    teacherStepAccept(objAccept).then((response) => {
                        if (response.code == 1) {
                            isLoader(false)
                            TOAST_SUCCESS(response.message);
                            setData(prevData => ({ ...prevData, step_3: "2" }));
                        } else {
                            isLoader(false)
                            TOAST_ERROR(response.message);
                        }
                    });
                } catch (error) {
                    TOAST_ERROR("Error..!!");
                }
            }
        });
    }

    const handleReject = () => {
        if (!isCommentSent) {
            TOAST_WARNING("Please send your comment first before rejecting.");
            return;
        }

        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to reject teacher background details?",
            showCancelButton: true,
            confirmButtonText: "Reject",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    var objReject = {
                        teacher_id: teacherID,
                        email: data.email,
                        accept: "3",
                        step: "3",
                        accept_for: "1",
                        teacher_name: name
                    };
                    isLoader(true)
                    teacherStepAccept(objReject).then((response) => {
                        if (response.code == 1) {
                            isLoader(false)
                            TOAST_SUCCESS(response.message);
                            setData(prevData => ({ ...prevData, step_3: "3" }));
                            setIsCommentSent(false);
                        } else {
                            isLoader(false)
                            TOAST_ERROR(response.message);
                        }
                    });
                } catch (error) {
                    TOAST_ERROR("Error..!!")
                }
            }
        });
    }

    const handleAcceptReupload = () => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to accept the new background check?",
            showCancelButton: true,
            confirmButtonText: "Accept",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    var objAccept = {
                        teacher_id: teacherID,
                        email: data.email,
                        action: "accept",
                        teacher_name: name
                    };
                    isLoader(true);
                    approveRejectBgReupload(objAccept).then((response) => {
                        if (response.code == 1) {
                            isLoader(false);
                            TOAST_SUCCESS(response.message);
                            GetTBackgroundData();
                        } else {
                            isLoader(false);
                            TOAST_ERROR(response.message);
                        }
                    });
                } catch (error) {
                    TOAST_ERROR("Error..!!");
                }
            }
        });
    }

    const handleRejectReupload = () => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to reject the new background check?",
            input: "textarea",
            inputLabel: "Reject reason",
            inputPlaceholder: "Enter the reason for rejection...",
            showCancelButton: true,
            confirmButtonText: "Reject",
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return "Please enter the reject reason.";
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                var objReject = {
                    teacher_id: teacherID,
                    email: data.email,
                    action: "reject",
                    reject_reason: result.value.trim(),
                    teacher_name: name
                };
                isLoader(true);
                approveRejectBgReupload(objReject).then((response) => {
                    isLoader(false);
                    if (response.code == 1) {
                        TOAST_SUCCESS(response.message);
                        GetTBackgroundData();
                    } else {
                        TOAST_ERROR(response.message);
                    }
                }).catch(() => {
                    isLoader(false);
                    TOAST_ERROR("Error..!!");
                });
            }
        });
    }

    const fileInputs = useRef([]);
    const resetFileInputs = () => {
        fileInputs.current.forEach((input) => {
            input.value = '';
        });
    };

    const commentSchema = Yup.object({
        comment: Yup.string()
    });

    const Email = data.email;
    const commentForm = useFormik({
        initialValues: {
            comment: '',
        },
        validationSchema: commentSchema,

        onSubmit: async (commentData) => {
            if (commentData.comment.trim() != "") {
                commentData.action_id = data.id
                commentData.action_type = "300"
                commentData.id = teacherID;
                commentData.email = Email;
                commentData.comment_for = 1; //comment_for 1 = teacher , 2 = organization , 3 = organization_teacher
                commentData.step = 3;
                commentData.name = name
                isLoader(true)
                sendCommentNew(commentData).then((response) => {
                    if (response.code == 1) {
                        TOAST_SUCCESS(response.message);
                        commentForm.resetForm();
                        resetFileInputs();
                        setIsCommentSent(true);
                        GetTBackgroundData();
                        GetTApplicationComments();
                        isLoader(false)
                    } else {
                        TOAST_ERROR(response.message);
                        isLoader(false)
                    }
                });
            }
        },
    });

    const displayError = (fieldName) =>
        commentForm.touched[fieldName] && commentForm.errors[fieldName];

    const [selectedFile, setSelectedFile] = useState(null);
    const [docModal, setDocModal] = useState(false);

    const openModal = (url) => {
        setSelectedFile(url);
        setDocModal(true);
    };

    const closeModal = () => {
        setSelectedFile(null);
        setDocModal(false);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <header className="dashboard-toolbar d-lg-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
                <div className="d-flex align-items-center">
                    <a className="menu-toggle align-items-center d-lg-none d-flex">
                        <i className="fa fa-bars" />
                    </a>
                    <a href="index.php" className="d-lg-none d-block brand-logo">
                        <img src="./assets/images/logo.png" alt="logo" />
                    </a>
                </div>
            </div>
        </header>
        <section className="main_sec">
            <div className="mt-4 mx-5 mb-5">
                <div>
                    <span onClick={handleBack}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                </div>
                {(Object.keys(data).length > 0 ? (
                    <>
                        <p className="ms-3 fs-3 fw-500 text-center mb-4">Teacher Background Details</p>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col col-lg-10 mb-4 mb-lg-0">
                                <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                    <div className="row g-0">
                                        <div className="col-md-12">
                                            <div className="card-body p-4">
                                                <h6 className="mb-2">Information</h6>
                                                <hr className="mt-0 mb-4" />
                                                <div className="row pt-1">
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-600">Will you teach children, under 18 years old?</p>
                                                        <p className="text-muted mt-1">{data.teach_children}</p>
                                                    </div>
                                                    {data.teach_children === "yes" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">Are You Currently A Certified School Board Teacher?</p>
                                                            <p className="text-muted mt-1">{data.certified_school_board}</p>
                                                        </div>
                                                    }

                                                    {data.certified_school_board === "yes" &&
                                                        <>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Teaching Certificate</p>
                                                                {/* {data.teacher_certificate && (
                                                                    <a href={data.teacher_certificate
                                                                    } className="text-purple underline mt-1">View Certificate</a>
                                                                )} */}
                                                                {data.teacher_certificate && (
                                                                    <a onClick={() => openModal(data.teacher_certificate)} className="text-purple underline mt-1">View Certificate</a>
                                                                )}
                                                            </div>

                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Teacher registration number</p>
                                                                <p className="text-muted mt-1">{data.registration_number}</p>
                                                            </div>
                                                        </>
                                                    }

                                                    {data.teach_children === "yes" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">Are you currently teaching with a school board or at a private school?</p>
                                                            <p className="text-muted mt-1">{data.private_school}</p>
                                                        </div>
                                                    }

                                                    {data.private_school == "yes" &&
                                                        <>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">School Name</p>
                                                                <p className="text-muted mt-1">{data.school_name}</p>
                                                            </div>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Full Address Of The School</p>
                                                                <p className="text-muted mt-1">{data.school_address}</p>
                                                            </div>

                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">School Contact Phone Number</p>
                                                                <p className="text-muted mt-1">{data.school_contact}</p>
                                                            </div>

                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">School Contact Email Address</p>
                                                                <p className="text-muted mt-1">{data.school_email}</p>
                                                            </div>

                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Please upload a valid background check to teach children under 18 years as per your country requirements.  We accept a valid (not expired) background check, it does not have to have our company information.</p>
                                                                {/* {data.teacher_back_info && (
                                                                    <a href={data.teacher_back_info} className="text-purple underline mt-1">View Document</a>
                                                                )} */}
                                                                {data.teacher_back_info && (
                                                                    <a onClick={() => openModal(data.teacher_back_info)} className="text-purple underline mt-1">View Document</a>
                                                                )}
                                                            </div>

                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Expiry Date Of The Background Check - Month And Year</p>
                                                                {/* <p className="text-muted mt-1">{data.expiry_date}</p> */}
                                                                <p className="text-muted mt-1">{new Date(data.expiry_date).toLocaleDateString('en-GB')}</p>
                                                            </div>
                                                        </>
                                                    }

                                                    {(data.private_school == "no" && data.certified_school_board == "no") &&
                                                        <>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">To legally teach children, you are required to have a safety check completed as per your country requirement.
                                                                </p>
                                                            </div>

                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Do You Have A Valid Legal Check ? </p>
                                                                <p className="text-muted mt-1">{data.legal}</p>
                                                            </div>
                                                        </>
                                                    }

                                                    {data.legal === "yes" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">Please Upload </p>
                                                            {/* {data.teacher_valid_check && (
                                                                <a href={data.teacher_valid_check} className="text-purple underline mt-1">View Document</a>
                                                            )} */}
                                                            {data.teacher_valid_check && (
                                                                <a onClick={() => openModal(data.teacher_valid_check)} className="text-purple underline mt-1">View Document</a>
                                                            )}
                                                        </div>
                                                    }

                                                    {data.legal === "no" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">Please contact  your local police station and upload the check required for teaching children under 18 years of age.
                                                            </p>
                                                            <p className="fw-600 mt-2">The following requirements are necessary to teach children below 18 years of age. Please upload this document as per the country you live in:
                                                            </p>
                                                            <p className="text-muted mt-1">{data.country_livein}</p>
                                                        </div>
                                                    }

                                                    {data.country_livein == "Australia" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">If You Reside In Australia - Work With Children Check</p>
                                                            {data.teacher_document && data.teacher_document.length > 0 ? (
                                                                data.teacher_document.map((doc, index) => (
                                                                    <div key={doc.id} className="mt-1">
                                                                        {/* <a href={doc.teacher_certificate} target="_blank" rel="noopener noreferrer" className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a> */}
                                                                        <a onClick={() => openModal(doc.teacher_certificate)} className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-gray mt-1">No documents available.</p>
                                                            )}
                                                        </div>
                                                    }
                                                    {data.country_livein == "Canada" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">If You Reside In Canada - Vulnerable Sector Check
                                                            </p>
                                                            {data.teacher_document && data.teacher_document.length > 0 ? (
                                                                data.teacher_document.map((doc, index) => (
                                                                    <div key={doc.id} className="mt-1">
                                                                        {/* <a href={doc.teacher_certificate} target="_blank" rel="noopener noreferrer" className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a> */}
                                                                        <a onClick={() => openModal(doc.teacher_certificate)} className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-gray mt-1">No documents available.</p>
                                                            )}
                                                        </div>
                                                    }
                                                    {data.country_livein == "New Zealand" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">If You Reside In New Zeland - National Criminal Background Check</p>
                                                            {data.teacher_document && data.teacher_document.length > 0 ? (
                                                                data.teacher_document.map((doc, index) => (
                                                                    <div key={doc.id} className="mt-1">
                                                                        {/* <a href={doc.teacher_certificate} target="_blank" rel="noopener noreferrer" className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a> */}
                                                                        <a onClick={() => openModal(doc.teacher_certificate)} className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-gray mt-1">No documents available.</p>
                                                            )}
                                                        </div>
                                                    }
                                                    {data.country_livein == "Singapore" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">If You Reside In Singapore - Complete Criminal Background Check </p>
                                                            {data.teacher_document && data.teacher_document.length > 0 ? (
                                                                data.teacher_document.map((doc, index) => (
                                                                    <div key={doc.id} className="mt-1">
                                                                        {/* <a href={doc.teacher_certificate} target="_blank" rel="noopener noreferrer" className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a> */}
                                                                        <a onClick={() => openModal(doc.teacher_certificate)} className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-gray mt-1">No documents available.</p>
                                                            )}
                                                        </div>
                                                    }
                                                    {data.country_livein == "UK" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">If You Reside In UK - Enhanced Database Check</p>
                                                            {data.teacher_document && data.teacher_document.length > 0 ? (
                                                                data.teacher_document.map((doc, index) => (
                                                                    <div key={doc.id} className="mt-1">
                                                                        {/* <a href={doc.teacher_certificate} target="_blank" rel="noopener noreferrer" className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a> */}
                                                                        <a onClick={() => openModal(doc.teacher_certificate)} className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-gray mt-1">No documents available.</p>
                                                            )}
                                                        </div>
                                                    }
                                                    {data.country_livein == "USA" &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">If You Reside In The USA - Two Checks Are Required. County-Wide Criminal Background Check And Sex Offender Registry Search
                                                            </p>
                                                            {data.teacher_document && data.teacher_document.length > 0 ? (
                                                                data.teacher_document.map((doc, index) => (
                                                                    <div key={doc.id} className="mt-1">
                                                                        {/* <a href={doc.teacher_certificate} target="_blank" rel="noopener noreferrer" className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a> */}
                                                                        <a onClick={() => openModal(doc.teacher_certificate)} className="text-purple underline">
                                                                            View Document {index + 1}
                                                                        </a>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-gray mt-1">No documents available.</p>
                                                            )}
                                                        </div>
                                                    }

                                                    {data.legal === "no" &&
                                                        <>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">A description of the position – Include the subjects you will teach with StudentScholars- </p>
                                                                <p className="text-muted mt-1">{data.org_position}</p>
                                                            </div>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600 mt-1">- The name of the organization – StudentScholars </p>
                                                                <p className="fw-600 mt-1">- Address of the organization – 7725 Birchmount Road, Unit 38, Markham , Ontario L3R 9X3, Canada</p>
                                                                <p className="fw-600 mt-1">- Staffing the position – Online teacher</p>
                                                            </div>
                                                        </>
                                                    }

                                                    {data.teach_children === "no" &&
                                                        <>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Have You Been Convicted For Violence, Sexual Abuse, Child Abuse, Or Neglect?</p>
                                                                <p className="text-muted mt-1">{data.convicted}</p>
                                                            </div>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Do You Have Offences Relating To Possession Or Supply Of Illegal Drugs?</p>
                                                                <p className="text-muted mt-1">{data.offences}</p>
                                                            </div>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Do You Have Any Outstanding Crimes That May Affect The Safety Of Our Learners?
                                                                </p>
                                                                <p className="text-muted mt-1">{data.outstanding}</p>
                                                            </div>

                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Have You Been Convicted Of Fraud And Deception, Internet Crimes, Statutory Crimes Or Criminal Intent?</p>
                                                                <p className="text-muted mt-1">{data.convicted_fraud}</p>
                                                            </div>
                                                            <div className="col-12 mb-4">
                                                                <p className="fw-600">Have You Been Barred From Teaching Children And Adults In Any Country?</p>
                                                                <p className="text-muted mt-1">{data.barred}</p>
                                                            </div>
                                                        </>
                                                    }

                                                    <div className="col-12 mb-4">
                                                        <p className="fw-600"> Optional: Any additional information you would like us to know
                                                        </p>
                                                        <p className="text-muted mt-1">{data.additional_info}</p>
                                                    </div>

                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500"> Full Name</p>
                                                        <p className="text-muted mt-1">{data.full_name}</p>
                                                    </div>

                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Your Country of Residence:</p>
                                                        <p className="text-muted mt-1">{data.country_residence}</p>
                                                    </div>

                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Date : </p>
                                                        <p className="text-muted mt-1">
                                                            {new Date(data.updated_at).toLocaleDateString('en-GB')}
                                                        </p>
                                                    </div>

                                                    {/* <div className="col-12 mb-4">
                                                        <p className="fw-500">Admin Comments</p>
                                                        <p className="text-muted mt-1">{data.comments}</p>
                                                    </div> */}

                                                </div>

                                                <form className="custom_form mt-4" name="commentForm" onSubmit={commentForm.handleSubmit}>

                                                    <div className="form-group mb-4">
                                                        <p className="fw-500 mb-2">Any comments you have, please add them here for the teacher.</p>
                                                        <textarea type="text" className="form-control" name="comment" value={commentForm.values.comment} rows="5" cols="33" onChange={commentForm.handleChange} ></textarea>
                                                        {displayError("comment") && (
                                                            <div className="text-danger">{commentForm.errors.comment}</div>
                                                        )}
                                                        <div className="button mt-2 mb-2 d-flex justify-content-end">
                                                            <button type="submit" className="btn-theme px-4 py-2  text-center text-dif-black fw-500 bg-yellow mb-xl-0 mb-3 d-inline-block">Send</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                {(data.step_3 == 0 || data.step_3 == 1) &&
                                                    <div className="d-flex justify-content-center mt-3">
                                                        <button className="btn-theme bg-yellow mx-1" onClick={() => handleAccpet()}>
                                                            {data.step_3 == "2" ? "Accepted" : "Accept"}
                                                        </button>
                                                        <button className="btn-theme mx-1" onClick={() => handleReject()}>
                                                            {data.step_3 == "3" ? "Rejected" : "Reject"}
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {(data.new_valid_legal_check && data.new_expiry_date) && (
                                    <div className="card mb-3 p-3 border-warning" style={{ borderRadius: ".5rem", borderWidth: "2px" }}>
                                        <div className="card-body p-4">
                                            <h6 className="mb-2 text-warning fw-bold">New Background Check Uploaded — Pending Review</h6>
                                            <hr className="mt-0 mb-4" />
                                            <div className="row pt-1">
                                                <div className="col-12 mb-4">
                                                    <p className="fw-600">New Background Check Document</p>
                                                    {data.full_new_valid_legal_check ? (
                                                        <a onClick={() => openModal(data.full_new_valid_legal_check)} className="text-purple underline mt-1" style={{ cursor: "pointer" }}>View Document</a>
                                                    ) : (
                                                        <p className="text-muted mt-1">Document uploaded</p>
                                                    )}
                                                </div>
                                                <div className="col-12 mb-4">
                                                    <p className="fw-600">New Expiry Date</p>
                                                    <p className="text-muted mt-1">{new Date(data.new_expiry_date).toLocaleDateString('en-GB')}</p>
                                                </div>
                                            </div>
                                            <p className="text-muted text-center mb-3" style={{ fontSize: "0.875rem" }}>
                                                Accepting will move the new document and expiry date to the active background check record.
                                            </p>
                                            <div className="d-flex justify-content-center mt-3">
                                                <button className="btn-theme bg-yellow mx-1" onClick={() => handleAcceptReupload()}>
                                                    Accept
                                                </button>
                                                <button className="btn-theme mx-1" onClick={() => handleRejectReupload()}>
                                                    Reject
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {data.reupload_history?.length > 0 && (
                                    <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                        <div className="card-body p-4">
                                            <h6 className="mb-2 fw-bold">Background Check Update History</h6>
                                            <hr className="mt-0 mb-4" />
                                            {data.reupload_history.map((item, index) => (
                                                <div key={item.id} className={`row pt-1 ${index < data.reupload_history.length - 1 ? "border-bottom mb-3 pb-2" : ""}`}>
                                                    <div className="col-md-3 mb-3">
                                                        <p className="fw-600">Reviewed On</p>
                                                        <p className="text-muted mt-1">{new Date(item.created_at).toLocaleDateString('en-GB')}</p>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <p className="fw-600">Document</p>
                                                        {item.full_valid_legal_check ? (
                                                            <a onClick={() => openModal(item.full_valid_legal_check)} className="text-purple underline mt-1" style={{ cursor: "pointer" }}>View Document</a>
                                                        ) : (
                                                            <p className="text-muted mt-1">-</p>
                                                        )}
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <p className="fw-600">Expiry Date</p>
                                                        <p className="text-muted mt-1">{item.expiry_date ? new Date(item.expiry_date).toLocaleDateString('en-GB') : "-"}</p>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <p className="fw-600">Status</p>
                                                        <p className={`mt-1 fw-600 ${item.status === "accepted" ? "text-success" : "text-danger"}`}>
                                                            {item.status === "accepted" ? "Accepted" : "Rejected"}
                                                        </p>
                                                    </div>
                                                    {item.status === "rejected" && item.reject_reason && (
                                                        <div className="col-12 mb-3">
                                                            <p className="fw-600">Reject Reason</p>
                                                            <p className="text-muted mt-1" style={{ whiteSpace: "pre-wrap" }}>{item.reject_reason}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {commentsList?.length > 0 && (
                                    <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                        <div className="row g-0">
                                            <div className="col-md-12">
                                                <div className="card-body p-4">
                                                    <DataTable
                                                        persistTableHead
                                                        columns={columns}
                                                        data={commentsList}
                                                        pagination
                                                        customStyles={customStyles}
                                                        className="custom-data-table"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <div>
                        <p className="text-center fs-5 fw-500 text-danger mt-5">The Teacher has not filled out the Background Details Form.</p>
                    </div>
                )
                )}
            </div>
        </section>

        {docModal && <FileModal isOpen={docModal} fileUrl={selectedFile} onClose={closeModal} />}
    </>
}

